var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTimetypeSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vvovib7tra",
    d: "M20.453 22.482V7.532H1.547v14.95h18.906zM15.869 0h2.464v2.417h1.203c.665 0 1.242.24 1.73.72.49.48.734 1.045.734 1.698v16.748c0 .652-.244 1.218-.733 1.698-.49.48-1.066.719-1.731.719H2.464c-.684 0-1.266-.24-1.745-.72C.239 22.802 0 22.236 0 21.584V4.835c0-.653.24-1.219.719-1.698.479-.48 1.06-.72 1.745-.72h1.203V0H6.13v2.417h9.738V0zm1.262 13.209v6.014H11v-6.014h6.13z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -56) translate(40 40) translate(20 10) translate(0 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "17ioaaj17b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vvovib7tra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#vvovib7tra"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#17ioaaj17b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V24H0z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimetypeSchedule);
export default __webpack_public_path__ + "static/media/icon-timetype-schedule.572a611388501fcaf32306b6538cf591.svg";
export { ForwardRef as ReactComponent };